import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AdminMenu } from "../../Components/Navbar/Menu";
import "./Breadcrumb.scss";
import { Stack } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export const findBreadcrumbPath = (menu, currentPath, pathTrail = []) => {
  for (const item of menu) {
    // A menu entry with a sub-menu is a dropdown GROUP (Utilites, Wallet, ...): it opens a list, it is not a page.
    const newPathTrail = [
      ...pathTrail,
      { title: item.title, path: item.path, isGroup: item?.subMenu?.length > 0 },
    ];

    if (item?.path === currentPath) {
      return newPathTrail;
    }

    if (item?.subMenu?.length > 0) {
      const foundPath = findBreadcrumbPath(
        item?.subMenu,
        currentPath,
        newPathTrail
      );
      if (foundPath) return foundPath;
    }
  }
  return null;
};

// Pages inside a menu page, not in the menu themselves: the trail of the page they belong to, then their own name. The way
// back is an in-app link, so the list keeps its filters as it does with the page's own Back to List.
const INNER_PAGES = [{ pattern: /^\/onlinePolicy\/view\/form\/[^/]+$/, parent: "/onlinePolicy", title: "Policy Details" }];

export const innerPageTrail = (menu, currentPath) => {
  const page = INNER_PAGES.find((p) => p.pattern.test(currentPath));
  if (!page) return null;
  const parents = findBreadcrumbPath(menu, page.parent) || [];
  return [...parents.map((crumb) => (crumb.isGroup ? crumb : { ...crumb, inApp: true })), { title: page.title, current: true }];
};

const Breadcrumb = () => {
  const location = useLocation();

  // The Add Money page has its own Back button instead of a breadcrumb.
  // no breadcrumb on the Dashboard, Add Money, or a policy's History page (2026-10-22: it has its own header)
  if (
    location.pathname === "/dashboard" ||
    location.pathname === "/addPolicyWalletMoney" ||
    /^\/onlinePolicy\/view\/history\//.test(location.pathname)
  ) {
    return null;
  }

  // pages reached from the profile menu (not the navbar menus) have no menu trail of their own
  const OUTSIDE_MENU = { "/serverControl": [{ title: "Server Control", path: "/serverControl" }] };
  const breadcrumbTrail =
    findBreadcrumbPath(AdminMenu, location.pathname) ||
    innerPageTrail(AdminMenu, location.pathname) ||
    OUTSIDE_MENU[location.pathname] ||
    [];

  const fullBreadcrumbTrail = [
    { title: "Home", path: "/dashboard" },
    ...breadcrumbTrail,
  ];

  return (
    <nav>
      <Stack direction={"row"} alignItems={"center"}>
        {fullBreadcrumbTrail.map((crumb, index) => (
          <div className="breadcrumb" key={index}>
            {crumb.current ? (
              <span className="text-color breadcrumb-current">{crumb.title}</span>
            ) : crumb.isGroup && index < fullBreadcrumbTrail.length - 1 ? (
              // A group has no page of its own (its path, e.g. "/utilies", matches no route and opened a blank page).
              <span className="text-color">{crumb.title}</span>
            ) : crumb.inApp ? (
              <Link className="text-color" to={crumb.path}>
                {crumb.title}
              </Link>
            ) : (
              <a className="text-color" href={crumb.path}>
                {crumb.title}
              </a>
            )}
            {index < fullBreadcrumbTrail.length - 1 && (
              <span
                style={{
                  padding: "0px 10px 0px 10px",
                }}>
                <ArrowForwardIosIcon
                  style={{
                    fontSize: "13px",
                  }}
                />
              </span>
            )}
          </div>
        ))}
      </Stack>
    </nav>
  );
};

export default Breadcrumb;
